/* eslint-disable no-unused-vars */
import axios from 'axios';
import {ConsoleLog} from './ConsoleHelper';

export function updateHeaders() {
  return function (dispatch, getstate) {
    const state = getstate();
    const {appState} = state;
    const {authtoken, user} = appState;
    ConsoleLog('updateHeaders', appState);
    axios.defaults.headers.get['Accept'] = 'application/json';
    axios.defaults.headers.post['Accept'] = 'application/json';
    if (authtoken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${authtoken}`;
    }
  };
}
